// Status options
export const statusOptions = [
  { label: 'All jobs', value: 'all' },
  { label: 'Open jobs', value: 'true' }
]

// Date options
export const dateOptions = [
  { label: 'All time', value: 'all' },
  { label: 'Past 24 hours', value: 'day' },
  { label: 'Past 3 days', value: '3days' },
  { label: 'Past week', value: 'week' },
  { label: 'Past month', value: 'month' }
]

// Experience level options
export const experienceOptions = [
  { label: 'All experience levels', value: 'all' },
  { label: 'Experienced', value: 'EXPERIENCED' },
  { label: 'Junior or switchers', value: 'JUNIOR' },
  { label: 'New grads', value: 'NEW_GRAD' },
  { label: 'No experience level specified', value: 'UNSPECIFIED' }
]